exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\r\n\r\n.total-spacer {\r\n  width: 20%;\r\n  margin-right: 30px;\r\n}\r\n\r\n.total {\r\n  font-weight: 600;\r\n  font-size: 1.3em;\r\n  margin-top: 30px\r\n}\r\n\r\n.button-addphase{\r\n  margin-right: 35px;\r\n}\r\n\r\n.button-submit {\r\n  margin-top: 10px;\r\n}", ""]);

